import { Box, styled } from '@mui/material';

import {
  MAP_OVERLAY_VIEW_HEIGHT,
  MAP_OVERLAY_VIEW_OFFSET_LEFT,
} from '../../constants';
import { UnitedStatesIcon } from '../../icons';

const PREFIX = 'CC-UsaMap';
export const usaMapClasses = {
  root: `${PREFIX}-root`,
  usaMapSVG: `${PREFIX}-usaMapSVG`,
} as const;

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root,
})(() => ({
  [`&.${usaMapClasses.root}`]: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },

  [`& .${usaMapClasses.usaMapSVG}`]: {
    pointerEvents: 'none',
    fill: '#1d2a37',
    '& text': {
      paintOrder: 'stroke',
      stroke: '#1D2A37',
      strokeWidth: '3px',
    },
  },
}));

export const UsaMap = () => (
  <Root className={usaMapClasses.root}>
    <UnitedStatesIcon
      id="usaMapSVG"
      width="100%"
      fill="#1d2a37"
      viewBox={`${MAP_OVERLAY_VIEW_OFFSET_LEFT} 0 1232 ${MAP_OVERLAY_VIEW_HEIGHT}`}
      className={usaMapClasses.usaMapSVG}
    />
  </Root>
);
